import React from 'react';

const DetailFacture = function () {
    return <div>DetailFacture</div>;
};

export default DetailFacture;
